const firebaseConfig = {
    apiKey: "AIzaSyAQiI-LFIAXRS9UJ4Jy8mkQHTwb9EQHmS4",
    authDomain: "ema-jhon-simple-841a8.firebaseapp.com",
    databaseURL: "https://ema-jhon-simple-841a8.firebaseio.com",
    projectId: "ema-jhon-simple-841a8",
    storageBucket: "ema-jhon-simple-841a8.appspot.com",
    messagingSenderId: "240909972451",
    appId: "1:240909972451:web:2f67123573714eb65aa6d6"
  };
  export default firebaseConfig;